export default function PHP_MySQLSelect() {
  return (
    <div>
      <h1>PHP_MySQLSelect</h1>
    </div>
  );
}
